import { branch, compose, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { selectCorporateProfile } from 'src/store/selectors/customerProfile'

const HousingTypeContainer = compose(
  connect(state => {
    const { equalHousingType } = selectCorporateProfile(state) || {}
    return { equalHousingType }
  }),
  branch(props => !props.equalHousingType, renderNothing)
)

export default HousingTypeContainer
